<div id="header">
    <div class="row ">
        <div class="col-3 row">
            <div class="ml-4">
                <a routerLink='/dashboard' (click)="closeSb()">
                    <img src="../../assets/images/SIGELAM-LOGO-revu.png" alt="" height="40">
                    <!--img src="../../../assets/images/SIGELAM-LOGO-revu.png" height="130" class="position-relative" style="top: -45px;"-->
                </a>
            </div>
            <!--div class="d-lg-block text-dark text-truncate">
                <a routerLink='/dashboard'>
                    <span class="text-success">Système Informatisé de Gestion des</span><br>
                    <span class="text-info">Laboratoires d'Analyses Médicales</span>
                </a>
            </div-->
        </div>
        <div class="col text-truncate" >
            <div class="row d-flex justify-content-center text-truncate" >
                <div class="text-dark position-relative d-flex justify-content-center" style="bottom: 5px; right:10px ; transform: translateX(-8%);" >
                    <span  style="color: rgb(7, 94, 151); font-family: Arial !important; font-weight:bolder; font-size: 40px;">
                        {{ currentUser.labo.nom}}
                    </span>
                        <img [src]="currentUser.labo.logo" height="55" class="position-relative img m-3" style="top: -12px;">
                    <span  style="color: rgb(7, 94, 151);  font-family: Arial !important; font-weight:bolder; font-size: 40px;">
                              {{ currentUser.labo.prenom }}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-2 row text-info float-right m-0 mr-3 p-0" id="user-info">
            <div class="col-7 text-truncate text-right float-right p-0 m-0" id="user-info-text">
                <span class="font-weight-bold">{{ this.currentUser.user.nom }}</span>
                <br>
                    {{ this.currentUser.profile.profile_name | titlecase}}
            </div>
            <div class="col-5 row col-md-6">
                <div class="col-6" >
                    <span class="h1 text-dark material-icons">manage_accounts</span>
                </div>
                <div class="col-5 mt-2 float-right">
                    <button type="button" class="btn dropdown-toggle" id="dropdown-icon"
                        aria-haspopup="true" aria-expanded="false" data-toggle="dropdown">
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdown-icon">
                        <a routerLink="/profile" class="dropdown-item"><span class="material-icons">account_circle</span> Profil</a>
                        <a  class="dropdown-item btn"><span class="material-icons">help</span> Aide</a>
                        <a class="dropdown-item btn" (click)="openModalLogout('500ms', '0ms')"><span class="material-icons">logout</span> Deconnexion</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
